import React from 'react'
import '../css/About.css'
import asset from '../assets/images'
import VisionMission from '../components/VisionMission';
import BehindLens from '../components/BehindLens';

const About = () => {
  return (
    <div className="about-carousel">
      <div className="slides">
        <div className="slide first">
          <img src={asset.about_hero} alt="About Image 1" />
          <div className="carousel-text">
            <h1>About Us</h1>
          </div>
        </div>
      </div>
      <VisionMission/>
      <BehindLens/>
    </div>
    
  );
};

export default About
